import React, { createContext, useEffect, useMemo, useState } from "react";

import i18n from "i18n-js";
import ls from "local-storage";

export const LocalizationContext = createContext();
LocalizationContext.displayName = "Localization Context";

const Locale = ({ children }) => {
  const [locale, setLocale] = useState("el-GR");

  const localizationContext = useMemo(
    () => ({
      t: (scope, options) => i18n.t(scope, { locale, ...options }),
      locale,
      setLocale,
    }),
    [locale]
  );

  useEffect(() => {
    fetchLocaleFromStorage();
  }, []);

  const fetchLocaleFromStorage = () => {
    try {
      const storedLocale = ls("locale");
      setLocale(storedLocale);
    } catch (error) {
      console.error("Error fetching locale from storage: ", error.message);
    }
  };

  i18n.fallbacks = true;
  i18n.translations = { el, en };

  return (
    <LocalizationContext.Provider value={localizationContext}>
      {children}
    </LocalizationContext.Provider>
  );
};

const en = {
  //SideBar translations
  "Dashboard": "Dashboard",
  "Edit Applications": "Edit Applications",
  "Nautical Crew List": "Nautical Crew List",
  "Delete Nautical Crew List": "Delete Nautical Crew List",
  "Are you sure you want to delete the selected Delete Nautical Crew List": "Are you sure you want to delete the selected Delete Nautical Crew List",
  "Sailors": "Sailors",
  "Ships": "Ships",
  "Parameters": "Parameters",
  "Application parameters": "Application parameters",
  "Nautical parameters": "Nautical parameters",
  "Geographical Departments": "Geographical Departments",
  "Geographical Departments Types": "Geographical Departments Types",
  "Port Authorities": "Port Authorities",
  "Port Authority Municipalities": "Port Authority Municipalities",
  "Document Categories": "Document Categories",
  "Documents": "Documents",
  "Pending Documents": "Pending Documents",
  "Please check rejected documents": "Please check rejected documents",
  "Application Kinds": "Application Kinds",
  "Documents per Kind": "Documents per Kind",
  "Applications Status": "Applications Status",
  "Flow Application Status": "Flow Application Status",
  "Referral Kinds": "Referral Kinds",
  "Referral Kinds per Flow": "Referral Kinds per Flow",
  "Leave Reasons": "Leave Reasons",
  "Diploma Kinds": "Diploma Kinds",
  "Sailor Specializations": "Sailor Specializations",
  "Ports": "Ports",
  "Mail Templates": "Mail Templates",
  "Select a theme": "Select a theme",
  "Select your style": "Select your style",
  "Approved / Rejected Applications History": "Approved / Rejected Applications History",
  "Applications History": "Applications History",
  "Application Info": "Application Info",


  //UI colors translations
  "Dark": "Dark",
  "Light": "Light",
  "Default": "Default",
  "Blue": "Blue",
  "Green": "Green",
  "Indigo": "Indigo",

  //Table UI translations
  'No records to display': 'No records to display',
  'Filter': 'Filter',
  'Are you sure you want to delete this row?': 'Are you sure you want to delete this row?',
  'Cancel': 'Cancel',
  'Drag headers': 'Drag headers here to create groups',
  'Grouped by': 'Grouped by',
  'Actions': 'Actions',
  'of': 'of',
  'rows': 'rows',
  'Rows per page': 'Rows per page',
  'First Page': 'First Page',
  'Previous Page': 'Previous Page',
  'Next Page': 'Next Page',
  'Last Page': 'Last Page',
  'Add or remove columns': 'Add or remove columns',
  'selected rows': 'selected rows',
  'Show Columns': 'Show Columns',
  'Export': 'Export',
  'Export as CSV': 'Export as CSV',
  'Export as PDF': 'Export as PDF',
  'Search': 'Search',
  'Edit': 'Edit',
  'Today': 'Today',
  'Id': 'Id',

  //network translations
  'A network error occured, please try again later': 'A network error occured, please try again later',

  //Sailors Table Translations
  'Insert New Sailor Details': 'Insert New Sailor Details',
  'Update Sailor Details': 'Update Sailor Details',
  'Sailor Identification Number': 'Sailor Identification Number',
  'Ameth': 'Sailor Worker Identification Number',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Father Name': 'Father Name',
  'Mother name': 'Mother Name',
  'Birth Date': 'Birth Date',
  'Modified By': 'Modified By',
  'Modified On': 'Modified On',
  'Sailor History': 'Sailor History',
  'Ship Name': 'Ship Name',
  'Sailor Specialization': 'Sailor Specialization',
  'Leave Reason': 'Leave Reason',
  "ANI": "ANI",
  'Diploma Kind': 'Diploma Kind',
  'Sailor': 'Sailor',
  'Sailor Details': 'Sailor Details',



  // Ships table Translations
  'Call Sign': 'Call Sign',
  'Ship': 'Ship',
  'Port': 'Port',
  'Owner Last Name': 'Owner Last Name',
  'Owner First Name': 'Owner First Name',
  "Ship's Register Number": "Ship's Register Number",
  "Ship's Name": "Ship's Name",
  "Nautical Crew's List Number": "Nautical Crew's List Number",
  "Previous Nautical Crew's List": "Previous Nautical Crew's List",
  'Issue Date': 'Issue Date',
  'Record Place': 'Record Place',
  'Nautical Crew Recruitment Start Date': 'Nautical Crew Recruitment Start Date',
  'Leave Place': 'Leave Place',
  'Leave Date': 'Leave Date',
  'Insert New Ship': 'Insert New Ship ',
  'Update Ship': 'Update Ship',
  'Delete Ship': 'Delete Ship',
  'Are you sure you want to delete the selected Ship': 'Are you sure you want to delete the selected Ship',
  'Ship Data': 'Ship Data',
  'Add new Ship Data': 'Add new Ship Data',
  'Edit Ship Data': 'Edit Ship Data',
  'Delete Ship Data': 'Delete Ship Data',
  'Are you sure you want to delete the selected Ship Data': 'Are you sure you want to delete the selected Ship Data',
  'Record Port ': 'Record Port',
  'Record Port': 'Record Port',
  'Issue Port': 'Issue Port',
  "Ship History": 'Ship History',
  "Crew": "Crew",
  'Delete Crew Member': 'Delete Crew Member',
  'Are you sure you want to delete the selected Crew Member': 'Are you sure you want to delete the selected Crew Member',
  'Add new Crew Person Data': 'Add new Crew Person Data',
  "Full Sailor Name": 'Full Sailor Name',
  'Nautical Recruitment Date': 'Nautical Recruitment Date',
  'Select Sailor': 'Select Sailor',
  'Fill Sailor Ship Details': 'Fill Sailor Details for Ship',
  'Back': 'Back',
  'Next': 'Next',
  'Please select one Sailor': 'Please select one Sailor',
  'View Ship History': 'View Ship History',
  'View Nautical Crew list': 'View Nautical Crew list',
  'View Crew': 'View Crew',
  'Update the Nautical Crew List': 'Update the Nautical Crew List',
  'Add new Nautical Crew List': 'Add new Nautical Crew List',
  'Are you sure you want to delete Nautical Crew List': 'Are you sure you want to delete Nautical Crew List',
  'Edit Crew Member': 'Edit Crew Member',
  'Search Sailor if already exists by Amina': 'Search Sailor if already exists by Amina',


  // column/tab names translations
  'Description': 'Description',
  'Full Description': 'Full Description',
  'Code': 'Code',
  'Parent Department': 'Parent Department',
  'Order': 'Order',
  'Type': 'Type',
  'Municipality / Department': 'Municipality / Department',
  'Port Authority': 'Port Authority',
  'Application Kind': 'Application Kind',
  'Document Category': 'Document Category',
  'Search from Service': 'Search from Service',
  'Required': 'Required',
  'Geographical Department Type': 'Geographical Department Type',
  'Parent Geographical Department': 'Parent Geographical Department',
  'From Status': 'From Status',
  'To Status': 'To Status',
  'Final Step': 'Final Step',
  'Rejection': 'Rejection',
  'Mail': 'Mail',
  'Mail Template': 'Mail Template',
  'Mail Τext': 'Mail Τext',
  'Address': 'Address',
  'Email Address': 'Email Address',
  'Phone Number': 'Phone Number',
  'Municipality / Geographical Department': 'Municipality / Geographical Department',
  'Application Status': 'Application Status',
  'Report Name': 'Report Name',
  'Referral Kind': 'Referral Kind',
  'Parent Port Authority': 'Parent Port Authority',
  'Document': 'Document',
  'Details': 'Details',
  'AFM': 'AFM',
  'Gender': 'Gender',
  'Nationality': 'Nationality',
  'Surname': 'Surname',
  'Applications waiting Port Authority action': 'Applications waiting Port Authority action',
  'Applications waiting citizen action': 'Applications waiting citizen action',
  'Edit Application': 'Edit Application',
  'For applicant': 'For applicant',
  'For service': 'For service',
  'None': 'None',
  'Temporary Save': 'Temporary Save',
  'Action': 'Action',
  'Effective Date': 'Effective Date',
  'Termination Date': 'Termination Date',
  'Filename': 'Filename',
  'File type': 'File type',
  'Pending': 'Pending',
  'Rejected': 'Rejected',
  'Reject': 'Reject',
  'Approved': 'Approved',
  'Approve': 'Approve',
  'Status': 'Status',
  'File': 'File',
  'Referral': 'Referral',
  'Referrals': 'Referrals',
  'Referral Template': 'Referral Template',
  'Modified Date': 'Modified Date',
  'Comments': 'Comments',
  'Next Status': 'Next Status',
  'From date': 'From date',
  'To date': 'To date',
  'Application max time': 'Application max time',
  'Settings': 'Settings',
  'Save': 'Save',
  '1st grade medical opinion duration': '1st grade medical opinion duration',
  '2nd grade medical opinion duration': '2nd grade medical opinion duration',
  'Medical report date': 'Medical report date',
  "Please provide the date of a' medical report": "Please provide the date of a' medical report",
  "Please provide the date of b' medical report": "Please provide the date of b' medical report",
  "Please provide b medical report date": "Please provide b medical report date",
  "Please provide a medical report date": "Please provide a medical report date",
  "Only the manager of port authority or admin can reject an application": "Only the manager of port authority or admin can reject an application",
  "Validation": "Validation",
  "Documents check": "Documents check",
  "Referrals check": "Referrals check",

  //application details

  'Name': 'Name',
  'Application Date': 'Application Date',
  'Protocol Number': 'Protocol Number',
  'ADT': 'ADT',
  'Father Surname': 'Father Surname',
  'Address Number': 'Address Number',
  'TK': 'TK',
  'Mobile Phone Number': 'Mobile Phone Number',
  'Email': 'Email',
  'AMKA': 'AΜΚΑ',
  'Meth': 'Meth',


  // concerned applicant  

  'Mother Surname': 'Mother Surname',
  'Mother Name': 'Mother Name',

  // Edit application texts
  'Application current status': 'Application current status',
  'Application kind': 'Application kind',
  'Application date': 'Application date',
  'Application Protocol Number': 'Application Protocol Number',
  'Application Details': 'Application Details',
  'Applicant details': 'Applicant details',
  'Applicant details concerning': 'Applicant details concerning',
  'Applicant Documents': 'Applicant Documents',
  'Application History': 'Application History',
  'Brief Summary of Application': 'Brief Summary of Application',
  'Print all application details': 'Print full description of application',
  'Print Application Details': 'Print Application Details for Record Keeping',
  'You can print a brief summary of the application of the Sailor': 'You can print a brief summary of the application of the Sailor',
  'You can print a summary of the application details of the Sailor': 'You can print a summary of the application details of the Sailor',
  "Application hasn't been finished,so you can't print the summary": "Application hasn't been finished,so you can't print the summary",
  'Print': 'Print',
  'Change application status': 'Change application status',
  'Comment': 'Comment',
  'View': 'View',
  'Rejection reason': 'Rejection reason',
  'Appointment date': 'Appointment date',
  'Waiting retrieval': 'Waiting retrival',
  'Delivered': 'Delivered',
  'Appointment date for nautical paper retrival': 'Appointment date for nautical paper retrival',
  'Please choose between the two dates you want to make an appointment with the citizen': 'Please choose between the two dates you want to make an appointment with the citizen',
  "Last comments": "Last comments",
  "Retired up to 64 year old": "Retired up to 64 year old",
  "Education level": "Education level",
  "Not Retired": "Not Retired",
  "Μale": "Μale",
  "Female": "Female",
  "Elementary school Graduate": "Elementary school Graduate",
  "High school graduate or higher education graduate": "High school graduate or higher education graduate",


  //Create Dialog translations
  'Add new Application Kind': 'Add new Application Kind',
  'Fill in the form below and click on Add to add a new Application Kind': 'Fill in the form below and click on Add to add a new Application Kind',
  'Add new Application Status': 'Add new Application Status',
  'Fill in the form below and click on Add to add a new Application Status': 'Fill in the form below and click on Add to add a new Application Status',
  'Add new Port Authority': 'Add new Port Authority',
  'Fill in the form below and click on Add to add a new Port Authority': 'Fill in the form below and click on Add to add a new Port Authority',
  'Add new Document Category': 'Add new Document Category',
  'Fill in the form below and click on Add to add a new Document Category': 'Fill in the form below and click on Add to add a new Document Category',
  'Add new Document': 'Add new Document',
  'Fill in the form below and click on Add to add a new Document': 'Fill in the form below and click on Add to add a new Document',
  'Add new Geographical Department Type': 'Add new Geographical Department Type',
  'Fill in the form below and click on Add to add a new Geographical Department Type': 'Fill in the form below and click on Add to add a new Geographical Department Type',
  'Add new Referral Kind': 'Add new Referral Kind',
  'Fill in the form below and click on Add to add a new Referral Kind': 'Fill in the form below and click on Add to add a new Referral Kind',
  'Add new Leave Reason': 'Add new Leave Reason',
  'Fill in the form below and click on Add to add a new Leave Reason': 'Fill in the form below and click on Add to add a new Leave Reason',
  'Add new Port': 'Add new Port',
  'Fill in the form below and click on Add to add a new Port': 'Fill in the form below and click on Add to add a new Port',
  'Add new Diploma': 'Add new Diploma',
  'Fill in the form below and click on Add to add a new Diploma': 'Fill in the form below and click on Add to add a new Diploma',
  'Add new Sailor Specialization': 'Add new Sailor Specialization',
  'Fill in the form below and click on Add to add a new Sailor Specialization': 'Fill in the form below and click on Add to add a new Sailor Specialization',
  'Add new Geographical Department': 'Add new Geographical Department',
  'Fill in the form below and click on Add to add a new Geographical Department': 'Fill in the form below and click on Add to add a new Geographical Department',
  'Add new Document per Kind': 'Add new Document per Kind',
  'Fill in the form below and click on Add to add a new Document per Kind': 'Fill in the form below and click on Add to add a new Document per Kind',
  'Add a new Mail Template': 'Add a new Mail Template',
  'Fill in the form below and click on Add to add a new Mail Template': 'Fill in the form below and click on Add to add a new Mail Template',
  'Add Municipalities to Port Authority': 'Add Municipalities to Port Authority',
  'Fill in the form below and click on Add to add a new Municipalities to Port Authority': 'Fill in the form below and click on Add to add a new Municipalities to Port Authority',
  'Add new Flow Application Status': 'Add new Flow Application Status',
  'Fill in the form below and click on Add to add a new Flow Application Status': 'Fill in the form below and click on Add to add a new Flow Application Status',
  'Add Referral Kinds to Flow': 'Add Referral Kinds to Flow',
  'Fill in the form below and click on Add to add a Referral Kind to Application Flow / Status': 'Fill in the form below and click on Add to add a Referral Kind to Application Flow / Status',


  //Edit Dialog translation
  'Edit Application Kind': 'Edit Application Kind',
  'Fill in the form below and then click on Save to update the Application Kind': 'Fill in the form below and then click on Save to update the Application Kind',
  'Edit Application Status': 'Edit Application Status',
  'Fill in the form below and then click on Save to update the Application Status': 'Fill in the form below and then click on Save to update the Application Status',
  'Edit Port Authority': 'Edit Port Authority',
  'Fill in the form below and click on Save to update the Port Authority': 'Fill in the form below and click on Save to update the Port Authority',
  'Edit Document Category': 'Edit Document Category',
  'Fill in the form below and then click on Save to update the Document Category': 'Fill in the form below and then click on Save to update the Document Category',
  'Edit Document': 'Edit Document',
  'Fill in the form below and then click on Save to update the Document': 'Fill in the form below and then click on Save to update the Document',
  'Edit Geographical Department Type': 'Edit Geographical Department Type',
  'Fill in the form below and then click on Save to update the Geographical Department Type': 'Fill in the form below and then click on Save to update the Geographical Department Type',
  'Edit Referral Kind': 'Edit Referral Kind',
  'Fill in the form below and then click on Save to update the Referral Kind': 'Fill in the form below and then click on Save to update the Referral Kind',
  'Edit Leave Reason': 'Edit Leave Reason',
  'Fill in the form below and then click on Save to update the Leave Reason': 'Fill in the form below and then click on Save to update the Leave Reason',
  'Edit Port': 'Edit Port',
  'Fill in the form below and then click on Save to update the Port': 'Fill in the form below and then click on Save to update the Port',
  'Edit Diploma': 'Edit Diploma',
  'Fill in the form below and then click on Save to update the Diploma': 'Fill in the form below and then click on Save to update the Diploma Kind',
  'Edit Sailor Specialization': 'Edit Sailor Specialization',
  'Fill in the form below and then click on Save to update the Sailor Specialization': 'Fill in the form below and then click on Save to update the Sailor Specialization',
  'Edit Geographical Department': 'Edit Geographical Department',
  'Fill in the form below and then click on Save to update the Geographical Department': 'Fill in the form below and then click on Save to update the Geographical Department',
  'Edit Document per Kind': 'Edit Document per Kind',
  'Fill in the form below and then click on Save to update the Document per Kind': 'Fill in the form below and then click on Save to update the Document per Kind',
  'Edit Mail Template': 'Edit Mail Template',
  'Fill in the form below and then click on Save to update the Mail Template': 'Fill in the form below and then click on Save to update the Application Kind',
  'Pick what kind of referral file you want to Upload, press on Upload button to pick a file from the computer': 'Pick what kind of referral file you want to Upload, press on Upload button to pick a file from the computer',

  //Delete Dialog translation
  'Delete Application Kind': 'Delete Application Kind',
  'Are you sure you want to delete the selected Application Kind': 'Are you sure you want to delete the selected Application Kind',
  'Delete Application Status': 'Delete Application Status',
  'Are you sure you want to delete the selected Application Status': 'Are you sure you want to delete the selected Application Status',
  'Delete Port Authority': 'Delete Port Authority',
  'Are you sure you want to delete the selected Port Authority': 'Are you sure you want to delete the selected Port Authority',
  'Delete Document Category': 'Delete Document Category',
  'Are you sure you want to delete the selected Document Category': 'Are you sure you want to delete the selected Document Category',
  'Delete Document Per Kind': 'Delete Document Per Kind',
  'Are you sure you want to delete the selected Document Per Kind': 'Are you sure you want to delete the selected Document Per Kind',
  'Delete Geographical Department': 'Delete Geographical Department',
  'Are you sure you want to delete the selected Geographical Department': 'Are you sure you want to delete the selected Geographical Department',
  'Delete Geographical Department Type': 'Delete Geographical Department Type',
  'Are you sure you want to delete the selected Geographical Department Type': 'Are you sure you want to delete the selected Geographical Department Type',
  'Delete Referral Kind': 'Delete Referral Kind',
  'Are you sure you want to delete the selected Referral Kind': 'Are you sure you want to delete the selected Referral Kind',
  'Delete Leave Reason': 'Delete Leave Reason',
  'Are you sure you want to delete the selected Leave Reason': 'Are you sure you want to delete the selected Leave Reason',
  'Delete Sailor Specialization': 'Delete Delete Sailor Specialization',
  'Are you sure you want to delete the selected Sailor Specialization': 'Are you sure you want to delete the selected Sailor Specialization',
  'Delete Port': 'Delete Port',
  'Are you sure you want to delete the selected Port': 'Are you sure you want to delete the selected Port',
  'Delete Sailor': 'Delete Sailor',
  'Are you sure you want to delete the selected Sailor with Sailor Identification Number': 'Are you sure you want to delete the selected Sailor with Sailor Identification Number',
  'Delete Diploma': 'Delete Diploma',
  'Are you sure you want to delete the selected Diploma': 'Are you sure you want to delete the selected Diploma',
  'Delete Mail Template': 'Delete Mail Template',
  'Are you sure you want to delete the selected Mail Template': 'Are you sure you want to delete the selected Mail Template',
  'Delete Application Flow / Status': 'Delete Application Flow / Status',
  'Are you sure you want to delete the selected Application Flow / Status': 'Are you sure you want to delete the selected Application Flow / Status',
  "Are you sure you want to delete the selected Application Referral": "Are you sure you want to delete the selected Application Referral",

  //Other dialogs texts
  'Application Kind Details': 'Application Kind Details',
  'Are you sure you want to reject the application?': 'Are you sure you want to reject the application?',
  'Please confirm that it has been updated regarding the required supporting documents which you will need to upload in order to successfully complete your registration for the service': 'Please confirm that it has been updated regarding the required supporting documents which you will need to upload in order to successfully complete your registration for the service',
  //Buttons and messages translations
  'Add': 'Add',
  'Add to list': 'Add to list',
  'Temporary save': 'Temporary save',
  'Delete': 'Delete',
  'Field is required': 'Field is required',
  'Field requires a number': 'Field requires a number',
  'Field requires a phone number': 'Field requires a phone number',
  'Too long': 'Too long',
  'Please provide a valid email address': 'Please provide a valid email address',
  'Invalid phone number': 'Invalid phone number',
  'List is empty': 'List is empty',
  'Both fields required to add Referral Kind to Application Flow / Status': 'Both fields required to add Referral Kind to Application Flow / Status',
  'Municipality added successfully to Port Authority': 'Municipality added successfully to Port Authority',
  'Municipality removed successfully from Port Authority': 'Municipality removed successfully from Port Authority',
  'Referral Kind added successfully to Flow Application Status': 'Referral Kind added successfully to Flow Application Status',
  'Referral Kind removed successfully from Flow Application Status': 'Referral Kind removed successfully from Flow Application Status',
  'Referral Kind updated successfully': 'Referral Kind updated successfully',
  'Close': 'Close',
  'Update': 'Update',
  'Upload referral': 'Upload referral',
  'Please upload all required referrals to proceed': 'Please upload all required referrals to proceed',
  'There are documents pending review': 'There are documents pending review',
  ' There are rejected documents': 'There are rejected documents',
  'There are documents pending review There are rejected documents': 'There documents pending review or are rejected',
  'Please choose a status from available statuses to continue': 'Please choose a status from available statuses to continue',
  'Application status changed successfully': 'Application status changed successfully',
  'Statuses per Application Kind': 'Statuses per Application Kind',
  'Select file': 'Select file',
  'All port auhtorities stats': 'All port auhtorities stats',
  'No stats available': 'No stats available',
  'More information': 'More information',
  'Application form': 'Υπόδειγμα αίτησης',
  'You need to change the application status to proccess the application': 'You need to change the application status to proccess the application',
  'Reject application': 'Reject application',
  'Please fill all the fields': 'Please fill all the fields',
  'Please upload responsible declaration parental consent for minors': 'Please upload responsible declaration parental consent for minors',
  "Please upload birth certificate with Men's Registration Number": "Please upload birth certificate with Men's Registration Number",
  "Please upload birth certificate of military status for men": "Please upload birth certificate of military status for men",
  "Please upload father's marital status certificate for women": "Please upload father's marital status certificate for women",
  "Please upload Affidavit from the Port Authority / Service / Inventory Port Authority, loss / theft / total damage of the Maritime Booklet": "Please upload Affidavit from the Port Authority / Service / Inventory Port Authority, loss / theft / total damage of the Maritime Booklet",
  "Please upload Chest X-ray report": "Please upload Chest X-ray report",
  'Please provide appointment dates': 'Please provide appointment dates',
  'Warning': 'Warning',
  "Please upload proxy document": "Please upload e-gov authorization for applying for third parties",
  "Mobile number must be 10 digits": "Mobile number must be 10 digits",
  "Field must be only numbers": "Field must be only numbers",
  "Field must be 11 digits": "Field must be 11 digits",
  "Postal code must be 5 digits": "Postal code must be 5 digits",
  "Phone number must be 10 digits": "Phone number must be 10 digits",
  "Referrals creation": "Referrals creation",
  "Number required": "Number required",
  'Create': 'Create',
  'Ok': 'Ok',
  "Ani number must be at least 8 characters": "Ani number must be at least 8 characters",
  "There can be only one submitted application for new nautical document issuance": "There can be only one submitted application for new nautical document issuance",
  "Pick what kind of referral file you want to create, choose from dropdown which referral to show": "Pick what kind of referral file you want to create, choose from dropdown which referral to show",
  "Drag and drop a file here or click": "Drag and drop a file here or click",
  "Preview": "Preview",
  "Minors under 16 years old can't submit new applications": "Minors under 16 years old can't submit new applications",
  "Afm must be 9 digits": "Afm must be 9 digits",
  "Appearing": "Appearing",
  "results": "results",
  "from": "from",
  "next": "next",
  'results sum': 'results sum',
  'previous': 'previous',

  "Wrong": "Wrong",
  "Confirm": "Confirm",
  "Form submitted successfully": "Form submitted successfully",
  "Document code": "Document code",
  "Return": "Return",

  //GDPR Translation
  'Chapter 5': 'CHAPTER 5',
  'Information about the Processing of Personal Data': 'INFORMATION ABOUT THE PROCESSING OF PERSONAL DATA',
  'GdprText': ['The Ministry of Shipping and Island Policy / Coast Guard-Hellenic Coast Guard Headquarters / Maritime Labor Directorate informs you that the processing of personal data is carried out in accordance with the provisions of Regulation (EU) 2016/679 (General Regulation on Data Protection) and .4624 / 2019 (137 Α´).The use and processing of the above personal data collected will be carried out exclusively for the processing of your request, for purposes of exercising the responsibilities of the Maritime Labor Directorate. The legal basis for the elaboration is the compliance with a legal obligation and the fulfillment of duties performed in the public interest and in the exercise of public authority. For the exercise of your rights (information, access, correction, restriction of processing and objection as the case may be) you can contact ', 'dner@hcg.gr', ' or by mail to the postal address: Akti Vassiliadis, Portal E1-E2, PC 185 10, Piraeus, in view of the Maritime Labor Directorate.'],
  'GdprOfficer': ['Data Protection Officer Y.NA.NP: ', 'https: //www.ynanp.gr/el/contact/epikoinwnia-dpo'],
  'Gdprlastparagraph': ['Detailed information has been posted on the website of the Hellenic Coast Guard Headquarters ', 'www.hcg.gr', ' and on the website of the Ministry of Shipping and Island Policy ', 'www.ynanp.gr', ' in the section ´΄For the Citizen΄΄'],

  "Your A' dregree medical document has been rejected, if you want to apply for review of the decision please download the review referral from referrals tabs, fill the missing fields and upload it on documents tabs at review document": "Your A' dregree medical document has been rejected, if you want to apply for review of the decision please download the review referral from referrals tabs, fill the missing fields and upload it on documents tabs at review document",

  //symbols
  '?': '?',
  "User": "User",
  "Administrator": "Administrator",
  "Manager": "Manager",
  "Employee": "Employee",

  // External user pages
  // Dashboard
  'Choose the kind of application you would like to submit and press "New Application" to start': 'Choose the kind of application you would like to submit and press "New Application" to start',
  'New application': 'New application',
  'Myself': 'Myself',
  'Another person': 'Another person',

  // My applications
  'My applications': 'My applications',

  // New application  
  "Is the application for you or for another person?": "Is the application for you or for another person?",
  'Submit': 'Submit',
  'Cancel application': 'Cancel application',
  "Are you sure you want to leave this page? Any unsaved changes will be lost": "Are you sure you want to leave this page? Any unsaved changes will be lost",
  'Your information': 'Your information',
  'Information of the person you are applying for': 'Information of the person you are applying for',
  'Date of birth': 'Date of birth',
  'Place of birth': 'Place of birth',
  'Place of staying': 'Place of staying',
  "Place of registration in Greece": "Place of registration in Greece",
  "Congratulations! Your application has been submitted successfully with protocol number: ": "Congratulations! Your application has been submitted successfully with protocol number: ",
  "Congratulations! Your application has been saved successfully!": "Congratulations! Your application has been saved successfully!",
  "You will be informed about the progress of your application by e-mail as soon as possible": "You will be informed about the progress of your application by e-mail as soon as possible",
  "You can see your application at any time by going to 'My applications' page": "You can see your application at any time by going to 'My applications' page",
  "Documents list": "Documents list",
  'Upload file': 'Upload file',
  'Required documents missing': 'Required documents missing',
  'Initial submission': 'Initial submission',
  'Action required from you': "Action required from you",
  'No': 'No',
  'Yes': 'Yes',
  'Old status': 'Old status',
  'New status': 'New status',
  "To continue editing and submit it, you can go to 'My applications' page": "To continue editing and submit it, you can go to 'My applications' page",
  "The document has been approved": "The document has been approved",
  "The document has been rejected": "The document has been rejected",
  "The document is being processed": "The document is being processed",
  "Reason": "Reason",
  "There are documents that have been rejected by the service": "There are documents that have been rejected by the service",
  "Please upload new ones": "Please upload new ones",
  "An error occured": "An error occured",
  "No referrals": "No referrals",
  "For the issuing of your document, you can arrive on": "For the issuing of your document, you can arrive from",
  "bringing with you 3 recent, coloured photographs 4,5 Χ 3,5": "bringing with you 3 recent, coloured photographs 4,5 Χ 3,5 and the receipts of purchase of the Nautical Issue",
  "to": "to",
  "Appointment": "Appointment",
  "Invalid email": "Invalid email",
  "Pickup place": "Pickup place",
  "Required Applicant Details missing": "Required Applicant Details missing",

  // Sectors
  "Sectors": "Sectors",
  "Sector": "Sector",
  "Delete Sector": "Delete Sector",
  "Are you sure you want to delete the selected Sector": "Are you sure you want to delete the selected Sector",
  "Add a new Sector": "Add a new Sector",
  "Fill in the form below and click on Add to add a new Sector": "Fill in the form below and click on Add to add a new Sector",
  "Fill in the form below and then click on Save to update the Sector": "Fill in the form below and then click on Save to update the Sector",
  "Please select a Sector": "Please select a Sector",


  // User statistics
  "User statistics": "User statistics",
  "Show": "Show",
  "Hide": "Hide",
  "column totals": "column totals",
  "column grand totals": "column grand totals",
  "row grand totals": "row grand totals",
  "Grand total": "Grand total",
  "Month": "Month",
  "Year": "Year",
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December",

  "Please fill in all required fields": "Please fill in all required fields",

  "Are you sure you want to cancel this application? This action cannot be undone and the progress of your application will be lost.": "Are you sure you want to cancel this application? This action cannot be undone and the progress of your application will be lost.",
  "Yes, I want to cancel this application": "Yes, I want to cancel this application",
  "No, I want to continue applying": "No, I want to continue applying",
  "Your application has been cancelled!": "Your application has been cancelled!",
  "Postpone": "Postpone",
  "You can fill in below any comments and desired dates for a new appointment": "You can fill in below any comments and desired dates for a new appointment",
  "Postpone appointment": "Postpone appointment",
  "Emails": "Emails",
  "Application id": "Application id",
  "Sent date": "Sent date",
  "Email body": "Email body",

  "Ship Configuration": "Ship Configuration",

  "Specialization": "Specialization",
  "Count": "Count",

  "Are you sure you want to delete the selected item": "Are you sure you want to delete the selected item",

  "Edit Sector": "Edit Sector",

  "Sail until": "Sail until",

  "Start Place": "Start Place",

  "View History": "View History",
  "Insert new Configuration": "Insert new Configuration",
  "Update Configuration": "Update Configuration",

  //Application Info
  "Choose appplication kind to view the associated info": "Choose appplication kind to view the associated info",
  "I have read the info about": "I have read the info about",
  "Nautical Issue Lost or Stolen": "Nautical Issue Lost or Stolen",
  "Change Color of Nautical Issue": "Change Color of Nautical Issue",
  "I certify that i have been informed": "I certify that I have been informed and consent to the maintenance and processing of my personal data for the processing of my application",
  "Blue Nautical": "P.D 104/2020 (Blue N.A)",
  "Red Nautical": "P.D 104/2020 (Red N.A)",
  "For high school graduates and higher level": "A) For high school graduates and higher level",
  "Holders of a degree or certificate of Rescue & Firefighting": "Β) Holders of a degree or certificate of Rescue & Firefighting",
  "For primary and higher level graduates": "A) For primary and higher level graduates",
  "Time limit for presenting a degree or certification of Rescue & Firefighting , 9 months from the issuance of the NF": "B) Time limit for presenting a degree or certification of Rescue & Firefighting , 9 months from the issuance of the NF",
  "Information about the application": "Information about the application",

  //Applications Summary
  "Applications Summary": "Applications Summary",
  "Image is not correct": "Image is not on correct Format. We need image with format .jpeg,.png,.jpg",
  "Image should up to 3mb": "Image should up to 3mb",
  "Image should 4:6": "Image should be on 4:6 format for example 800x1200",
  "Photo Requirements": " Image should be up to 3mb and with format .jpeg,.png,.jpg",
  "Reason for copy nautical issue": "Reason for copy nautical issue",
  "You can download here the form": "You can download here the form filled with the text but you need this to be signed via e-gov.gr",
  "Download": "Download",

  //Custom GovGr Translations
  "Field can't be edited": "Field can't be edited",
  "This your ΜΕΘ number": "This your ΜΕΘ number",
  "Day": "Day",
  "Invalid date": "Invalid date",
  "Choose Here": "Choose Here",

  // Amka Verification Page

  "Please type your AMKA number in the below field": "Please type your AMKA number in the below field",
  "Wrong AMKA": "Amka number is wrong. Please type your correct AMKA or go to a KEP to update your correct AMKA",
  "Gateway Data": "Gateway Data",
  "Please upload identification document": "Please upload identification document",
  "Field must be checked": "Field must be checked",
  "Didactic Year": "Graduation Didactic Year",
  "Please upload eparavolo_copy_nautical_issue": "Please upload Public Treasury receipt or collection duplicate or e-receipt €31.17 (code 3035) for ATTICA OR €41.17 for the rest of Greece (code 3036)",
  "Please upload your High Scool Diploma": "Please upload your High Scool Diploma",
  "Please upload your Primary School Leaving Certificate": "Please upload your Primary School Leaving Certificate",
  "criminal": "Criminal Records",
  "stratologia": "Military Service",
  "student_attendance": "Student Attendance",
  "digital_diploma": "Digital Diploma",
  "criminal_record_hasPines": "Has Criminal Record",
  "criminal_record_status": "Criminal Record Status",
  "criminal_record_requestId": "Criminal Record Request Id",
  "criminal_record_prdDate": "Criminal Record Issue Date",
  "criminal_record_prdNumber": "Criminal Record Issue Number",
  "stratologia_message": "Message About Military Status",
  "stratologia_status": "Military Status",
  "student_attendance_resultCode": "Has Finished as Student",
  "student_attendance_status": "Student Attendance Status",
  "digital_diploma_levelName": "Digital Diploma",
  "digital_diploma_status": "Digital Diploma Status",
  "mitroo": "Registry service",
  "mitroo_municipalityName": "Municipality",
  "mitroo_merida": "Family register",
  "mitroo_member": "Member",
  "mitroo_status": "Status",
  "mitroo_place_birth_id": "Place of birth ID",
  "mitroo_place_birth": "Place of birth",
  "mitroo_birthForeignCity": "Foreign city",
  "mitroo_nationality": "Nationality",
  "mitroo_port_auth": "Port authority",
  "mitroo_port_auth_id": "Port authority ID",
  "mitroo_gender": "Gender",
  "mitroo_dt_birth": "Date of birth",
  "mitroo_tk": "Zip code",
  "mitroo_address_nr": "Address number",
  "mitroo_address": "Address",
  "mitroo_moth_fname": "Mother name",
  "mitroo_moth_lname": "Mother surname",
  "mitroo_fath_lname": "Father surname",
  "mitroo_fath_fname": "Father name",
  "mitroo_ind_nr": "Identification number",
  "mitroo_fname": "Name",
  "mitroo_lname": "Surname",
  "Wrong_ADT": "If your ADT is wrong please upload it when you upload your documents",
  "Birth Country": "Birth Country",
  "Birth City Abroad": "Birth City Abroad",
  "eParavolo": "eParavolo",
  "Submit eParavolo": "Submit eParavolo",
  "Create eParavolo": "Create eParavolo",
  "eParavoloUseorCreate": "Below you can press Submit eParavolo to submit your paid and not used eParavolo so your application can go to next status,or you can create a new eParavolo and pay it through your Bank.",
  "Paravolo Code": "Paravolo Code",
  "Rf_Code_Payment": "RF Code Payment",
  "eParavoloCreated": "Eparavolo rf payment code is",
  "Application_not_status_eParavolo": "Your application status is not eParavolo yet so you can't create or submit your eParavolo",
  "eParavolo_not_payed": "EParavolo hasn't been yet payed",
  "eParavolo_bound": "EParavolo is bound , please issue a new one",
  "eParavolo_cancelled": "EParavolo is cancelled , please issue a new one",
  "eParavolo_Payment_Processing": "EParavolo payment is processing, please wait 1-2 days",
  "Please type your 20 digit Paravolo Code (NOT RF CODE)": "Please type your 20 digit Paravolo Code (NOT RF CODE)",
  "Paravolo RF Code": "Paravolo RF Code",
  "eParavoloPaymentCreated": "Eparavolo payment code is",
  "eParavolo_Use_BackOffice": "By click the button below you use the Paravolo that the customer has paid and you can go to the next status of issuing referral",
  "Paravolo has not been paid": "EParavolo hasn't been paid yet, or it is used , you must redirect user to submit new Paravolo that is paid",
  "useParavoloText": "Bind eParavolo",
  "eParavoloBound": "Eparavolo has been bound succesfully please go to next step and issue referral",
  "Application_not_status_eParavolo_backOffice": "Application is not on status eParavolo",
  "You have been automatically logged out for being idle for more than 1 hour":
    "You have been automatically logged out for being idle for more than 1 hour",
  "Data": "Data",
  "EParavolo is not bound": "EParavolo is not bound",
  "From": "From",
  "Please choose a date after which the applicant can arrive": "Please choose a date after which the applicant can arrive",
  "For the completion of your petition it is mandatory to validate your contact info": "For the completion of your petition it is mandatory to validate your contact info at (https://notify.gov.gr)",
  "In the case that information you see is not correct, please update your info": "In the case that information you see is not correct, please update your info"
};







const el = {
  //SideBar translations
  "Dashboard": "Dashboard",
  "Edit Applications": "Επεξεργασία Αιτήσεων",
  "Nautical Crew List": "Ναυτολόγιο",
  "Delete Nautical Crew List": "Διαγραφή Ναυτολογίου",
  "Are you sure you want to delete the selected Delete Nautical Crew List": "Θέλετε να διαγράψετε το συγκεκριμένο Ναυτολόγιο",
  "Sailors": "Ναυτικοί",
  "Ships": "Πλοία",
  "Parameters": "Παραμετρικά",
  "Application parameters": "Παραμετρικά Αιτήσεων",
  "Nautical parameters": "Παραμετρικά Ναυτολογίου",
  "Geographical Departments": "Γεωγραφικά Διαμερίσματα",
  "Geographical Departments Types": "Είδη Γεωγραφικών Διαμερισμάτων",
  "Port Authorities": "Λιμενικές Αρχές",
  "Port Authority Municipalities": "Δήμοι Λιμενικής Αρχής",
  "Document Categories": "Κατηγορίες Δικαιολογητικών",
  "Documents": "Δικαιολογητικά",
  "Pending Documents": "Εκκρεμή δικαιολογητικά",
  "Please check rejected documents": "Παρακαλούμε ελέγξτε τα δικαιολογητικά που έχουν απορριφθεί",
  "Application Kinds": "Είδη Αιτήσεων",
  "Documents per Kind": "Δικαιολογητικά ανά είδος Αίτησης",
  "Applications Status": "Status Aιτήσεων",
  "Flow Application Status": "Flow / Status Αιτήσεων",
  "Referral Kinds": "Είδη Παραπεμπτικών",
  "Referral Kinds per Flow": "Είδη παραπεμπτικών ανά Flow Status",
  "Leave Reasons": "Αιτιολογικό Απόλυσης",
  "Diploma Kinds": "Είδη Διπλωμάτων",
  "Sailor Specializations": "Ειδικότητες Ναυτολόγησης",
  "Ports": "Λιμάνια Νηολόγησης",
  "Mail Templates": "Πρότυπα Αλληλογραφίας",
  "Select a theme": "Επιλέξτε θέμα",
  "Select your style": "Επιλέξτε το στυλ σας",
  "Approved / Rejected Applications History": "Ιστορικό Ολοκληρωμένων / Απορριφθεισών Αιτήσεων",
  "Applications History": "Ιστορικό Αιτήσεων",
  "Application Info": "Πληροφορίες Αιτήσεων",


  //UI colors translations
  "Dark": "Σκοτεινό",
  "Light": "Φωτεινό",
  "Default": "Προεπιλεγμένο",
  "Blue": "Μπλε",
  "Green": "Πράσινο",
  "Indigo": "Ίντιγκο",

  //Table UI translations
  'No records to display': 'Δεν υπάρχουν δεδομένα',
  'Filter': 'Φίλτρο',
  'Are you sure you want to delete this row?': 'Σίγουρα να διαγραφεί αυτή η σειρά;',
  'Cancel': 'Ακύρωση',
  'Drag headers': 'Σείρετε επικεφαλίδες εδώ για να δημιουργήσετε ομάδες',
  'Grouped by': 'Ομαδοποιημένα κατά',
  'Actions': 'Επιλογές',
  'of': 'από',
  'rows': 'σειρές',
  'Rows per page': 'Σειρές ανά σελίδα',
  'First Page': 'Πρώτη Σελίδα',
  'Previous Page': 'Προηγούμενη Σελίδα',
  'Next Page': 'Επόμενη Σελίδα',
  'Last Page': 'Τελευταία Σελίδα',
  'Add or remove columns': 'Προσθήκη ή διαγραφή στηλών',
  'selected rows': 'επιλεγμένες σειρές',
  'Show Columns': 'Προβολή Στηλών',
  'Export': 'Εξαγωγή',
  'Export as CSV': 'Εξαγωγή σε Excel',
  'Export as PDF': 'Εξαγωγή σε PDF',
  'Search': 'Αναζήτηση',
  'Edit': 'Επεξεργασία',
  'Edit Application': 'Επεξεργασία Αίτησης',
  'Today': 'Σήμερα',
  'Id': 'Id',

  //network translations
  'A network error occured, please try again later': 'Σφάλμα δικτύου, παρακαλώ δοκιμάστε αργότερα.',

  //Sailors Table Translations
  'Insert New Sailor Details': 'Καταχωρήστε τα στοιχεία Ναυτικού',
  'Update Sailor Details': 'Ενημερώστε τα στοιχεία Ναυτικού',
  'Sailor Identification Number': 'Αριθμός Μητρώου',
  'Ameth': 'AΜΕΘ',
  'First Name': 'Όνομα',
  'Last Name': 'Επώνυμο',
  'Father Name': 'Όνομα Πατέρα',
  'Mother name': 'Όνομα Μητέρας',
  'Birth Date': 'Ημερομηνία Γεννήσεως',
  'Modified By': 'Τροποποίηση από',
  'Modified On': 'Ημερομηνία Τροποποίηση',
  'Sailor History': 'Ιστορικότητα Ναυτικού',
  'Ship Name': 'Όνομα Πλοίου',
  'Sailor Specialization': 'Ειδικότητα Ναυτολόγησης',
  'Leave Reason': 'Αιτιολογικό Απόλυσης',
  "ANI": "ΑΝΙ",
  'Diploma Kind': 'Είδος Διπλώματος',
  'Sailor': 'Ναυτικός',


  // Ships table Translations
  'Call Sign': 'Διεθνές Διακριτικό Πλοίου',
  'Ship': 'Πλοίο',
  'Port': 'Λιμάνι Νηολόγησης',
  'Owner Last Name': 'Επώνυμο Πλοιοκτήτη',
  'Owner First Name': "Όνομα Πλοιοκτήτη",
  "Ship's Register Number": "Αριθμός Νηολογίου",
  "Ship's Name": "Όνομα Πλοίου",
  "Nautical Crew's List Number": "Αριθμός Ναυτολογίου",
  "Previous Nautical Crew's List": "Προηγούμενο Ναυτολόγιο",
  'Issue Date': 'Ημερομηνία Έκδοσης',
  'Record Place': 'Τόπος Έκδοσης',
  'Nautical Crew Recruitment Start Date': 'Ημερομηνία Ναυτολόγησης',
  'Leave Place': 'Τόπος Απόλυσης',
  'Leave Date': 'Ημερομηνία Απόλυσης',
  'Insert New Ship': 'Καταχωρήστε Πλοίο',
  'Update Ship': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε τo Πλοίο',
  'Delete Ship': 'Διαγραφή Πλοίου',
  'Are you sure you want to delete the selected Ship': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Πλοίο',
  'Ship Data': 'Αρχείο Πλοίου',
  'Add new Ship Data': 'Προσθέστε ένα νέο Αρχείο Πλοίου',
  'Edit Ship Data': 'Επεξεργασία Αρχείου Πλοίου',
  'Delete Ship Data': 'Διαγραφή Αρχείου Πλοίου',
  'Are you sure you want to delete the selected Ship Data': 'Είστε σίγουροι ότι θελετε να διαγράψετε το Αρχείο Πλοίου',
  'Record Port': 'Λιμάνι Έκδοσης',
  'Issue Port': "Λιμάνι Έκδοσης",
  "Ship History": 'Αρχείο Πλοίου',
  "Crew": "Πλήρωμα",
  'Add new Crew Person Data': 'Προσθέστε ένα νέο μέλος Πληρώματος',
  "Full Sailor Name": 'Ονοματεπώνυμο Ναυτικού',
  'Nautical Recruitment Date': 'Ημερομηνία Ναυτολόγησης',
  'Select Sailor': 'Επιλέξτε Ναυτικό',
  'Fill Sailor Ship Details': 'Προσθέστε τα στοιχεία Ναυτικού για το Πλοίο',
  'Back': 'Προηγούμενο Βήμα',
  'Next': 'Επόμενο Βήμα',
  'Please select one Sailor': 'Παρακαλούμε επιλέξτε μόνο ένα Ναυτικό',
  'Sailor Details': 'Πληροφορίες Ναυτικού',
  'View Ship History': 'Προβολή Αρχείου Πλοίου',
  'View Nautical Crew list': 'Προβολή Ναυτολογίου',
  'View Crew': 'Προβολή Πληρώματος',
  'Update the Nautical Crew List': 'Ενημέρωση του Ναυτολογίου',
  'Add new Nautical Crew List': 'Καταχώρηση καινούριου Ναυτολογίου',
  'Are you sure you want to delete Nautical Crew List': 'Είστε σίγουροι ότι θελετε να διαγράψετε το Ναυτολόγιο',
  'Edit Crew Member': 'Επεξεργασία Στοιχειών Ναυτικού Πληρώματος',
  'Delete Crew Member': 'Διαγραφη Μέλους Πληρώματος',
  'Are you sure you want to delete the selected Crew Member': 'Είστε σίγουροι ότι θελετε να διαγράψετε το μέλος Πληρώματος',
  'Search Sailor if already exists by Amina': 'Αναζητήστε αν υπάρχει ο ναυτικός βάση του ΑΜΙΝΑ του',





  // columns/tab name translations
  'Description': 'Περιγραφή',
  'Full Description': 'Πλήρης Περιγραφή',
  'Code': 'Κωδικός',
  'Parent Department': 'Πατρικό Διαμέρισμα',
  'Order': 'Σειρά Ταξινόμησης',
  'Type': 'Τύπος',
  'Municipality / Department': 'Δήμος / Διαμέρισμα',
  'Port Authority': 'Λιμενική Αρχή',
  'Application Kind': 'Είδος Αίτησης',
  'Document Category': 'Κατηγορία Δικαιολογητικού',
  'Search from Service': 'Αναζήτηση από Υπηρεσία',
  'Required': 'Υποχρεωτικό',
  'Geographical Department Type': 'Είδος Γεωγραφικού Διαμερίσματος',
  'Parent Geographical Department': 'Πατρικό Γεωγραφικό Διαμέρισμα',
  'From Status': 'Από Status',
  'To Status': 'Τιμή Status',
  'Final Step': 'Τελικό Βήμα',
  'Rejection': 'Απόρριψη',
  'Mail': 'Χρήση Mail',
  'Mail Template': 'Πρότυπο Αλληλογραφίας',
  'Mail Text': 'Κείμενο αλληλογραφίας',
  'Address': 'Διεύθυνση',
  'Email Address': 'Διεύθυνση Email',
  'Phone Number': 'Αριθμός Τηλεφώνου',
  'Municipality / Geographical Department': 'Δήμος / Γεωγραφικό Διαμέρισμα',
  'Application Status': 'Status Αίτησης',
  'Report Name': 'Όνομα Report',
  'Referral Kind': 'Είδος Παραπεμπτικού',
  'Parent Port Authority': 'Πατρική Λιμενική Αρχή',
  'Document': 'Δικαιολογητικό',
  'Details': 'Λεπτομέρειες',
  'AFM': 'Α.Φ.Μ.',
  'Gender': 'Φύλο',
  'Nationality': 'Yπηκοότητα',
  'Surname': 'Επώνυμο',
  'Applications waiting Port Authority action': 'Αιτήσεις προς ενέργεια υπηρεσίας',
  'Applications waiting citizen action': 'Αιτήσεις προς ενέργεια πολίτη',
  'For applicant': 'Για αιτούντα',
  'For service': 'Για υπηρεσία',
  'Παραδόθηκε στον πολίτη - Ολοκληρώθηκε': 'Παραδόθηκε στον πολίτη - Ολοκληρώθηκε',
  'None': 'Κανένας',
  'Temporary Save': 'Προσωρινή Αποθήκευση',
  'Action': 'Ενέργεια',
  'Effective Date': 'Ημερομηνία Ισχύος',
  'Termination Date': 'Ημερομηνία Λήξης',
  'Filename': 'Όνομα αρχείου',
  'File type': 'Τύπος αρχείου',
  'Pending': 'Εκκρεμεί',
  'Rejected': 'Απορρίφθηκε',
  'Reject': 'Απόρριψη',
  'Approved': 'Εγκρίθηκε',
  'Approve': 'Έγκριση',
  'Status': 'Κατάσταση',
  'File': 'Αρχείο',
  'Referral': 'Παραπεμπτικό',
  'Referrals': 'Παραπεμπτικά',
  'Referral Template': 'Πρότυπο Παραπεμπτικού',
  'Modified Date': 'Ημ/νία Τροποποίησης',
  'Comments': 'Σχόλια',
  'Next Status': 'Επόμενο Status',
  'From date': 'Από ημ/νία',
  'To date': 'Eώς ημ/νία',
  'Application max time': 'Μέγιστος χρόνος αίτησης',
  'Settings': 'Ρυθμίσεις',
  'Save': 'Αποθήκευση',
  '1st grade medical opinion duration': "Διάρκεια Α'θμιας ιατρικής γνωμάτευσης",
  '2nd grade medical opinion duration': "Διάρκεια Β'θμιας ιατρικής γνωμάτευσης",
  'Medical report date': 'Ημερομηνία γνωμάτευσης',
  "Please provide the date of a' medical report": "Παρακαλώ εισάγετε την ημερομηνία της Α'θμιας υγειονομικής γνωμάτευσης",
  "Please provide the date of b' medical report": "Παρακαλώ εισάγετε την ημερομηνία της Β'θμιας υγειονομικής γνωμάτευσης",
  "Please provide b medical report date": "Παρακαλώ εισάγετε την ημερομηνία β'θμιας υγειονομικής γνωμάτευσης",
  "Please provide a medical report date": "Παρακαλώ εισάγετε την ημερομηνία α'θμιας υγειονομικής γνωμάτευσης",
  "Only the manager of port authority or admin can reject an application": "Μόνο ο διαχειριστής της λιμενικής αρχής ή ο κεντρικός διαχειριστής μπορεί να απορρίψει μια αίτηση",
  "Validation": "Μέθοδος επικύρωσης",
  "Documents check": "Έλεγχος δικαιολογητικών",
  "Referrals check": "Έλεγχος παραπεμπτικών",
  //application details

  'Name': 'Όνομα',
  'Application Date': 'Ημ/νία Αίτησης',
  'Protocol Number': 'Αριθμός Πρωτοκόλλου',
  'ADT': 'ΑΔΤ',
  'Father Surname': 'Επώνυμο Πατέρα',
  'Address Number': 'Αριθμός Διεύθυνσης',
  'TK': 'ΤΚ',
  'Mobile Phone Number': 'Αριθμός Κινητού Τηλεφώνου',
  'Email': 'Email',
  'AMKA': 'ΑΜΚΑ',
  'Meth': 'ΜΕΘ',

  // Applicant details concerning
  'Applicant Surname concerning': 'Επώνυμο Αιτούντα που αφορά',
  'Mother Surname': 'Επώνυμο Μητρός',
  'Mother Name': 'Όνομα Μητρός',


  // Edit application texts
  'Application current status': 'Τρέχων Status Αίτησης',
  'Application kind': 'Είδος Αίτησης',
  'Application date': 'Ημ/νία Αίτησης',
  'Application Protocol Number': 'Αριθμός πρωτοκόλλου Αίτησης',
  'Applicant details': 'Στοιχεία Αιτούντα',
  'Application Details': 'Στοιχεία Αίτησης',
  'Applicant details concerning': 'Στοιχεία Αιτούντα που αφορά',
  'Applicant Documents': 'Δικαιολογητικά Αιτούντα',
  'Application History': 'Ιστορικό Αίτησης',
  'Brief Summary of Application': 'ΣΥΝΟΠΤΙΚΟ ΕΚΤΥΠΩΤΙΚΟ ΑΙΤΗΣΕΩΝ',
  'Print all application details': 'ΕΚΤΥΠΩΤΙΚΟ ΑΙΤΗΣΗΣ',
  'Print Application Details': 'Εκτυπωτικά Αιτήσεων για Αρχειοθέτηση',
  'You can print a brief summary of the application of the Sailor': 'Μπορείτε να εκτυπώσετε μία συνοπτική αναφορά με την ολοκληρωμένη αίτηση του Ναυτικού',
  'You can print a summary of the application details of the Sailor': 'Μπορείτε να εκτυπώσετε μία αναφορά με όλα τα πεδία με την ολοκληρωμένη αίτηση του Ναυτικού',
  "Application hasn't been finished,so you can't print the summary": "H αίτηση δεν είναι ολοκληρωμένη,οπότε δεν μπορείτε να εκτυπώσετε την αναφορά",
  'Print': 'Εκτύπωση',
  'mutate': 'Αλλαγή Status Αίτησης',
  'Comment': 'Σχόλιο',
  'View': 'Προβολή',
  'Rejection reason': 'Λόγος Απόρριψης',
  'Appointment date': 'Ημερομηνία ραντεβού',
  'Waiting retrieval': 'Αναμονή παραλαβής',
  'Delivered': 'Παραδόθηκε',
  'Appointment date for nautical paper retrival': 'Ημερομηνία ραντεβού για παραλαβή ναυτικού φυλλαδίου',
  'Please choose between the two dates you want to make an appointment with the citizen': 'Παρακαλω επιλέξτε μεταξύ των δύο ημερομηνιών που θελετε να κλεισετε ραντεβου στον πολιτη',
  "Last comments": "Τελευταία σχόλια",
  "Retired up to 64 year old": "Συνταξιούχος έως 64 ετών",
  "Not Retired": "Μη Συνταξιούχος",
  "Education level": "Επίπεδο Εκπαίδευσης (κατ'ελάχιστο)",
  "Male": "ΑΡΡΕΝ",
  "Female": "ΘHΛY",
  "Elementary school Graduate": "Απόφοιτος Δημοτικού ή ανώτερης βαθμίδας",
  "High school graduate or higher education graduate": "Απόφοιτος Γυμνασίου ή ανώτερης βαθμίδας",



  //Create Dialog translations
  'Add new Application Kind': 'Προσθέστε ένα νέο Είδος Αιτήσεως',
  'Fill in the form below and click on Add to add a new Application Kind': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Είδος Αιτήσεως',
  'Add new Application Status': 'Προσθέστε ένα νέο Status Αιτήσεως',
  'Fill in the form below and click on Add to add a new Application Status': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Status Αιτήσεως',
  'Add new Port Authority': 'Προσθέστε μία νέα Λιμενική Αρχή',
  'Fill in the form below and click on Add to add a new Port Authority': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε μία νέα Λιμενική Αρχή',
  'Add new Document Category': 'Προσθέστε μία νέα Κατηγορία Δικαιολογητικού',
  'Fill in the form below and click on Add to add a new Document Category': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε μία νέα Κατηγορία Δικαιολογητικού',
  'Add new Document': 'Προσθέστε ένα νέο Δικαιολογητικό',
  'Fill in the form below and click on Add to add a new Document': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Δικαιολογητικό',
  'Add new Geographical Department Type': 'Προσθέστε ένα νέο Είδος Γεωγραφικού Διαμερίσματος',
  'Fill in the form below and click on Add to add a new Geographical Department Type': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Είδος Γεωγραφικού Διαμερίσματος',
  'Add new Referral Kind': 'Προσθέστε ένα νέο Είδος Παραπεμπτικού',
  'Fill in the form below and click on Add to add a new Referral Kind': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Είδος Παραπεμπτικού',
  'Add new Leave Reason': 'Προσθέστε ένα νέο Αιτιολογικό Απόλυσης',
  'Fill in the form below and click on Add to add a new Leave Reason': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Αιτιολογικό Απόλυσης',
  'Add new Port': 'Προσθέστε ένα νέο Λιμάνι Νηολόγησης',
  'Fill in the form below and click on Add to add a new Port': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Λιμάνι Νηολόγησης',
  'Add new Diploma': 'Προσθέστε ένα νέο Δίπλωμα',
  'Fill in the form below and click on Add to add a new Diploma': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Δίπλωμα',
  'Add new Sailor Specialization': 'Προσθέστε μία νέα Ειδικότητα Ναυτολόγησης',
  'Fill in the form below and click on Add to add a new Sailor Specialization': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε μία νέα Ειδικότητα Ναυτολόγησης',
  'Add new Geographical Department': 'Προσθέστε ένα νέο Γεωγραφικό Διαμέρισμα',
  'Fill in the form below and click on Add to add a new Geographical Department': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Γεωγραφικό Διαμέρισμα',
  'Add new Document per Kind': 'Προσθέστε ένα νέο Δικαιολογητικό ανά Είδος Αίτητης',
  'Fill in the form below and click on Add to add a new Document per Kind': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα νέο Δικαιολογητικό ανά Είδος Αίτητης',
  'Add a new Mail Template': 'Προσθήκη νέου Πρότυπου Αλληλογραφίας',
  'Fill in the form below and click on Add to add a new Mail Template': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε ένα Πρότυπο Αλληλογραφίας',
  'Add Municipalities to Port Authority': 'Προσθέστε Δήμους / Γεωγραφικά Διαμερίσματα στην Λιμενική Αρχή',
  'Fill in the form below and click on Add to add a new Municipalities to Port Authority': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε Δήμoυς / Γεωγραφικά Διαμερίσματα στην Λιμενική Αρχή',
  'Add new Flow Application Status': 'Προσθήκη νέου Flow / Status Αίτησης',
  'Fill in the form below and click on Add to add a new Flow Application Status': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε Flow / Status Αίτησης',
  'Add Referral Kinds to Flow': 'Προσθήκη Ειδών Παραπεμπτικών στο Flow / Status Αίτησης',
  'Fill in the form below and click on Add to add a Referral Kind to Application Flow / Status': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πιέστε Προσθήκη για να προσθέσετε Είδος Παραπεμπτικού στο Flow / Status Αίτησης',
  'Pick what kind of referral file you want to Upload, press on Upload button to pick a file from the computer': 'Επιλέξτε το είδος παραστατικού που θέλετε να μεταφορτώσετε. Πατήστε το κουμπί "Μεταφόρτωση Παραπεμπτικού" και επιλέξτε ένα αρχείο απο τον υπολογιστή σας',
  //Edit Dialog translations
  'Edit Application Kind': 'Επεξεργασία Είδους Αιτήσεως',
  'Fill in the form below and then click on Save to update the Application Kind': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Είδος Αιτήσεως',
  'Edit Application Status': 'Επεξεργασία Status Αιτήσεως',
  'Fill in the form below and then click on Save to update the Application Status': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Status Αιτήσεως',
  'Edit Port Authority': 'Επεξεργασία Λιμενικής Αρχής',
  'Fill in the form below and click on Save to update the Port Authority': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε την Λιμενική Αρχή',
  'Edit Document Category': 'Επεξεργασία Κατηγορίας Δικαιολογητικού',
  'Fill in the form below and then click on Save to update the Document Category': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε την Κατηγορία Δικαιολογητικού',
  'Edit Document': 'Επεξεργασία Δικαιολογητικού',
  'Fill in the form below and then click on Save to update the Document': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Δικαιολογητικό',
  'Edit Geographical Department Type': 'Επεξεργασία Είδους Γεωγραφικού Διαμερίσματος',
  'Fill in the form below and then click on Save to update the Geographical Department Type': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Είδος Γεωγραφικού Διαμερίσματος',
  'Edit Referral Kind': 'Επεξεργασία Είδος Παραπεμπτικού',
  'Fill in the form below and then click on Save to update the Referral Kind': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Είδος Παραπεμπτικού',
  'Edit Leave Reason': 'Επεξεργασία Αιτιολογικό Απόλυσης',
  'Fill in the form below and then click on Save to update the Leave Reason': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Αιτιολογικό Απόλυσης',
  'Edit Port': 'Επεξεργασία Λιμανιού Νηολόγησης',
  'Fill in the form below and then click on Save to update the Port': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Λιμάνι Νηολόγησης',
  'Edit Diploma': 'Επεξεργασία Διπλώματος',
  'Fill in the form below and then click on Save to update the Diploma': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Είδος Διπλώματος',
  'Edit Sailor Specialization': 'Επεξεργασία Ειδικότητας Ναυτολόγησης',
  'Fill in the form below and then click on Save to update the Sailor Specialization': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε την Ειδικότητα Ναυτολόγησης',
  'Edit Geographical Department': 'Επεξεργασία Γεωγραφικού Διαμερίσματος',
  'Fill in the form below and then click on Save to update the Geographical Department': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Γεωγραφικό Διαμέρισμα',
  'Edit Document per Kind': 'Επεξεργασία Δικαιολογητικού ανά είδος Αίτησης',
  'Fill in the form below and then click on Save to update the Document per Kind': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Δικαιολογητικό ανά είδος Αίτησης',
  'Edit Mail Template': 'Επεξεργασία Πρότυπου Αλληλογραφίας',
  'Fill in the form below and then click on Save to update the Mail Template': 'Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώσετε το Πρότυπο Αλληλογραφίας',

  //Delete Dialog translation
  'Delete Application Kind': 'Διαγραφή Είδους Αίτητης',
  'Are you sure you want to delete the selected Application Kind': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Είδος Αίτησης',
  'Delete Application Status': 'Διαγραφή Status Αίτησης',
  'Are you sure you want to delete the selected Application Status': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Status Αίτησης',
  'Delete Port Authority': 'Διαγραφή Λιμενικής Αρχής',
  'Are you sure you want to delete the selected Port Authority': 'Είστε σίγουροι ότι θελετε να διαγράψετε την επιλεγμένη Λιμενική Αρχή',
  'Delete Document Category': 'Διαγραφή Κατηγορίας Δικαιολογητικού',
  'Are you sure you want to delete the selected Document Category': 'Είστε σίγουροι ότι θελετε να διαγράψετε την επιλεγμένη Κατηγορία Δικαιολογητικού',
  'Delete Document Per Kind': 'Διαγραφή Δικαιολογητικού ανά είδος Αίτησης',
  'Are you sure you want to delete the selected Document Per Kind': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Δικαιολογητικό ανά Είδος Αίτησης',
  'Delete Geographical Department': 'Διαγραφή Γεωγραφικού Διαμερίσματος',
  'Are you sure you want to delete the selected Geographical Department': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Γεωγραφικό Διαμέρισμα',
  'Delete Geographical Department Type': 'Διαγραφή Είδους Γεωγραφικού Διαμερίσματος',
  'Are you sure you want to delete the selected Geographical Department Type': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Είδος Γεωγραφικού Διαμερίσματος',
  'Delete Referral Kind': 'Διαγραφή Είδους Παραπεμπτικού',
  'Are you sure you want to delete the selected Referral Kind': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Είδος Παραπεμπτικού',
  'Delete Leave Reason': 'Διαγραφή Αιτιολογικό Απόλυσης',
  'Are you sure you want to delete the selected Leave Reason': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Αιτιολογικό Απόλυσης',
  'Delete Sailor Specialization': 'Διαγραφή Ειδικότητας Ναυτολόγησης',
  'Are you sure you want to delete the selected Sailor Specialization': 'Είστε σίγουροι ότι θελετε να διαγράψετε την επιλεγμένη Ειδικότητα Ναυτολόγησης',
  'Delete Port': 'Διαγραφή Λιμανιού Νηολόγησης',
  'Are you sure you want to delete the selected Port': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Λιμάνι Νηολόγησης',
  'Delete Sailor': 'Διαγραφή Ναυτικού',
  'Are you sure you want to delete the selected Sailor with Sailor Identification Number': 'Είστε σίγουροι ότι θελετε να διαγράψετε τον επιλεγμένο Ναυτικό με Αριθμό Μητρώου: ',
  'Delete Diploma': 'Διαγραφή Διπλώματος',
  'Are you sure you want to delete the selected Diploma': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο  ',
  'Delete Mail Template': 'Διαγραφή Προτύπου Αλληλογραφίας',
  'Are you sure you want to delete the selected Mail Template': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Πρότυπο Αλληλογραφίας',
  'Delete Application Flow / Status': 'Διαγραφή Flow / Status Αίτησης',
  'Are you sure you want to delete the selected Application Flow / Status': 'Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Flow / Status Αίτησης',
  "Are you sure you want to delete the selected Application Referral": "Είστε σίγουροι ότι θελετε να διαγράψετε το επιλεγμένο Παραπεμπτικό",

  //Other dialogs texts
  'Application Kind Details': 'Λεπτομέρειες Είδους Αίτησης',
  'Are you sure you want to reject the application?': 'Είστε σίγουροι ότι θέλετε να απορρίψετε την αίτηση;',
  'Please confirm that it has been updated regarding the required supporting documents which you will need to upload in order to successfully complete your registration for the service': 'Παρακαλούμε να επιβεβαιώσετε ότι έχει ενημερωθεί σχετικά με τα απαιτούμενα δικαιολογητικά που θα πρέπει να ανεβάσετε προκειμένου να ολοκληρώσετε επιτυχώς την εγγραφή σας στην υπηρεσία',

  //Buttons and messages translations
  'Add': 'Προσθήκη',
  'Add to list': 'Προσθήκη στη λίστα',
  'Temporary save': 'Προσωρινή αποθήκευση',
  'Delete': 'Διαγραφή',
  'Field is required': 'Το πεδίο είναι υποχρεωτικό',
  'Field requires a number': 'Το πεδίο θα πρέπει να είναι αριθμός',
  'Field requires a phone number': 'To πεδίο χρειάζεται αριθμό τηλεφώνου',
  'Too long': 'Πολύ μεγάλο',
  'Please provide a valid email address': 'Παρακαλώ εισάγετε μία σωστή διεύθυνση email',
  'Invalid phone number': 'Λάθος αριθμός τηλεφώνου',
  'List is empty': 'Η λίστα είναι άδεια',
  'Both fields required to add Referral Kind to Application Flow / Status': 'Και τα 2 πεδία είναι υποχρεωτικά για να προσθέσετε Είδος Παραπεμπτικού στο Flow / Status Αίτησης',
  'Municipality added successfully to Port Authority': 'Ο Δήμος προστέθηκε με επιτυχία στο Λιμεναρχείο',
  'Municipality removed successfully from Port Authority': 'Ο δήμος καταργήθηκε με επιτυχία από το Λιμεναρχείο ',
  'Referral Kind added successfully to Flow Application Status': 'Το παραπεμπτικό προστέθηκε με επιτυχία στο Flow/Status Αίτησης',
  'Referral Kind removed successfully from Flow Application Status': 'Το παραπεμπτικό καταργήθηκε με επιτυχία από Flow/Status Αίτησης',
  'Referral Kind updated successfully': 'Το παραπεμπτικό ενημερώθηκε με επιτυχία',
  'Close': 'Κλείσιμο',
  'Update': 'Ενημέρωση',
  'Upload referral': 'Μεταφόρτωση παραπεμπτικού',
  'Please upload all required referrals to proceed': 'Μεταφορτώστε όλα τα απαραίτητα παραπεμπτικά για να συνεχίσετε',
  'There are documents pending review': 'Υπάρχουν δικαιολογητικά που εκκρεμούν για έλεγχο',
  ' There are rejected documents': 'Υπάρχουν δικαιολογητικά που έχουν απορριφθεί',
  'There are documents pending review There are rejected documents': 'Υπάρχουν δικαιολογητικά που εκκρεμούν για έλεγχο ή έχουν απορριφθεί',
  'Please choose a status from available statuses to continue': 'Επιλέξτε μια κατάσταση από τις διαθέσιμες καταστάσεις για να συνεχίσετε',
  'Application status changed successfully': 'Το Status της αίτησης άλλαξε επιτυχώς',
  'Statuses per Application Kind': 'Συνολικά Statuses ανά είδος αίτησης',
  'Select file': 'Επιλέξτε αρχείο',
  'All port auhtorities stats': 'Στατιστικά για όλες τις Λιμενικές Αρχές',
  'No stats available': 'Δεν υπάρχουν διαθέσιμα στατιστικά',
  'More information': 'Περισσότερες πληροφορίες',
  'Application form': 'Υπόδειγμα αίτησης',
  'You need to change the application status to proccess the application': 'Θα πρέπει να περάσετε την αίτηση σε status επεξεργασίας για να επεξεργαστείτε την αίτηση',
  'Reject application': 'Απόρριψη αίτησης',
  'Please fill all the fields': 'Παρακαλώ συμπληρώστε όλα τα πεδία',
  'Please upload responsible declaration parental consent for minors': 'Παρακαλώ μεταφορτώστε την υπεύθυνη δήλωση συγκατάθεσης γονέων',
  "Please upload birth certificate with Men's Registration Number": "Παρακαλώ ανεβάστε το πιστοποιητικό γεννήσεως με αριθμό Μητρώου Αρρένων για τους άνδρες",
  "Please upload birth certificate of military status for men": "Παρακαλώ ανεβάστε το πιστοποιητικό στρατολογικής κατάστασης για τους άνδρες",
  "Please upload father's marital status certificate for women": "Παρακαλώ ανεβάστε το πιστοποιητικό οικογενειακής κατάστασης του πατέρα για τις γυναίκες",
  "Please upload Affidavit from the Port Authority / Service / Inventory Port Authority, loss / theft / total damage of the Maritime Booklet": "Παρακαλώ ανεβάστε την ένορκη βεβαίωση από Λιμενική Αρχή/ Υπηρεσία /Απογράφουσα Λιμενική Αρχή, περί απώλειας/κλοπής/ολικής φθοράς Ναυτικού Φυλλαδίου",
  "Please upload Chest X-ray report": "Παρακαλώ ανεβάστε την γνωμάτευση Ακτινογραφίας Θώρακος",
  'Please provide appointment dates': 'Παρακαλώ εισάγετε τις ημερομηνίες του ραντεβού σωστά',
  "Mobile number must be 10 digits": "Ο αριθμός κινητού τηλεφώνου πρέπει να είναι ακριβώς 10 ψηφία",
  "Field must be only numbers": "Στο πεδίο πρέπει να είναι μόνο αριθμοί",
  "Field must be 11 digits": "Το πεδίο πρέπει να είναι 11 ψηφία",
  "Postal code must be 5 digits": "Ο Τ.Κ. πρέπει να είναι ακριβώς 5 ψηφία",
  "Phone number must be 10 digits": "Ο αριθμός τηλεφώνου πρέπει να είναι 10 ψηφία",
  "Referrals creation": "Δημιουργία παραπεμπτικών",
  "Number required": "Εισάγεται αριθμό",
  'Create': 'Δημιουργία',
  'Ok': 'Οκ',
  "Ani number must be at least 8 characters": "Ο αριθμός ΑΝΙ θα πρέπει να είναι τουλάχιστον 8 ψηφία",
  "There can be only one submitted application for new nautical document issuance": "Υπάρχει ήδη αίτηση για έκδοση ναυτικού φυλλαδίου για το συγκεκριμένο ΑΦΜ",
  "Pick what kind of referral file you want to create, choose from dropdown which referral to show": "Παρακαλώ επιλέξτε το είδος του παραπεμπτικού που θέλετε να δημιουργήσετε",
  "Drag and drop a file here or click": "Σύρετε και αποθέστε ένα αρχείο εδώ ή κάντε κλικ",
  "Preview": "Προεπισκόπηση",
  "Minors under 16 years old can't submit new applications": "Οι Ανήλικοι κάτω των 16 ετών δεν μπορούν να υποβάλουν νέες αιτήσεις",
  "Afm must be 9 digits": "Το ΑΦΜ πρέπει να είναι 9 ψηφία",
  "Appearing": "Εμφανίζονται",
  "results": "αποτελέσματα",
  "from": "από",
  "next": "Επόμενο",
  'results sum': 'σύνολο αποτελεσμάτων',
  'previous': 'Προηγούμενο',
  "Wrong": "Λάθος",
  "Confirm": "Επιβεβαίωση",
  "Form submitted successfully": "Η φόρμα υποβλήθηκε επιτυχώς",
  "Document code": "Ο κωδικός εγγράφου",
  "Return": "Επιστροφή",

  //GDPR Translation
  'Chapter 5': 'ΠΑΡΑΡΤΗΜΑ 5',
  'Information about the Processing of Personal Data': 'ΕΝΗΜΕΡΩΣΗ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΔΕΔΟΜΕΝΩΝ ΠΡΟΣΩΠΙΚΟΥ ΧΑΡΑΚΤΗΡΑ',
  'GdprText': ['To Υπουργείο Ναυτιλίας και Νησιώτικης Πολιτικής/Αρχηγείο Λιμενικού Σώματος-Ελληνικής Ακτοφυλακής/Διεύθυνση Ναυτικής Εργασίας σας ενημερώνει ότι η επεξεργασία των δεδομένων προσωπικού χαρακτήρα πραγματοποιείται σύμφωνα με τις διατάξεις του Κανονισμού (ΕΕ) 2016/679 (Γενικός Κανονισμός για την Προστασία Δεδομένων) και του ν.4624/2019(137 Α´). Η χρήση και επεξεργασία των ανωτέρω δεδομένων προσωπικού χαρακτήρα που συλλέγονται θα πραγματοποιηθεί αποκλειστικά για την διεκπεραίωση του αιτηματός σας, για σκοπούς άσκησης των αρμοδιοτήτων της Διεύθυνσης Ναυτικής Εργασίας. Νομική Βάση για την επεξεργασία είναι η συμμόρφωση με έννομη υποχρέωση και η εκπλήρωση καθηκόντων που εκτελούνται προς το δημόσιο συμφέρον και κατά την ενάσκηση δημόσιας εξουσίας. Για την άσκηση των δικαιωμάτων σας (ενημέρωσης,πρόσβασης,διόρθωσης,περιορισμού της επεξεργασίας και αντίρρησης κατά περίπτωση) δύναται να απευθύνεστε στο ', 'dner@hcg.gr', ' ή μέσω αλληλογραφίας στην ταχυδρομική διεύθυνση: Ακτή Βασιλειάδη, Πύλη Ε1-Ε2, Τ.Κ. 185 10, Πειραιάς , υπόψιν της Διεύθυνσης Ναυτικής Εργασίας.'],
  'GdprOfficer': ['Υπεύθυνος Προστασίας Δεδομένων Υ.ΝΑ.Ν.Π.: ', 'https://www.ynanp.gr/el/contact/epikoinwnia-dpo'],
  'Gdprlastparagraph': ['Αναλυτική ενημέρωση έχει αναρτηθεί στην ιστοσελίδα του Αρχηγείου Λιμενικού Σώματος-Ελληνικής ΑΚτοφυλακής ', 'www.hcg.gr', ' και στην ιστοσελίδα του Υπουργείου Ναυτιλίας και Νησιωτικής Πολιτικής ', 'www.ynanp.gr', ' στην ενότητα ´΄Για τον Πολίτη΄΄'],

  'Warning': 'Προσοχή',
  "Please upload proxy document": "Παρακαλώ μεταφορτώστε την εξουσιοδότηση, μέσω e-gov, για ηλεκτρονική υποβολή μέσω τρίτου προσώπου",
  "Accept": "Αποδοχή",
  "Review": "Αναθεώρηση",
  "Your A' dregree medical document has been rejected, if you want to apply for review of the decision please download the review referral from referrals tabs, fill the missing fields and upload it on documents tabs at review document": "Το ιατρικό σας έγγραφο πρωτοβάθμιας υγειονομικής εξέτασης έχει απορριφθεί, εάν θέλετε να κάνετε αίτηση για αναθεώρηση, παρακαλώ πατήστε στην καρτέλα των παραπεμπτικών, κατεβάστε και συμπληρώστε την αίτηση αναθεώρησης και έπειτα μεταφορτώστε την στην καρτέλα με τα δικαιολογητικά στο σημείο 'Αίτημα αναθεώρησης' και πατήστε το κουμπί 'Αναθεώρηση', αλλιώς εάν δέχεστε την απόφαση πατήστε υποβολή",
  //symbols
  '?': ';',
  'User': 'Χρήστης',
  "Administrator": "Διαχειριστής",
  "Manager": "Μάνατζερ",
  "Employee": "Υπάλληλος",

  // External user pages
  // Dashboard
  'Choose the kind of application you would like to submit and press "New Application" to start': 'Επιλέξτε το είδος αίτησης που θέλετε να υποβάλλετε πατώντας "Νέα αίτηση" σε μια από τις τρεις επιλογές παρακάτω',
  'New application': 'Νέα αίτηση',
  'Myself': 'Εμένα',
  'Another person': 'Kάποιον άλλον',

  // My applications
  'My applications': 'Οι αιτήσεις μου',

  // New application  
  "Is the application for you or for another person?": "Η αίτηση αφορά εσάς ή κάποιον άλλον;",
  'Submit': 'Υποβολή',
  'Cancel application': 'Ακύρωση αίτησης',
  "Are you sure you want to leave this page? Any unsaved changes will be lost": 'Σίγουρα θέλετε να φύγετε από αυτή τη σελίδα; Αλλαγές που δεν έχουν αποθηκευτεί θα χαθούν',
  'Your information': 'Τα στοιχεία σας',
  'Information of the person you are applying for': 'Στοιχεία του ατόμου για το οποίο κάνετε την αίτηση',
  'Date of birth': 'Ημερομηνία γέννησης',
  'Place of birth': 'Τόπος γέννησης',
  'Place of staying': 'Δήμος Διαμονής',
  'Place of registration in Greece': 'Τόπος εγγραφής στο Δημοτολόγιο της Ελλάδας',
  "Congratulations! Your application has been submitted successfully with protocol number: ": "Συγχαρητήρια! Η αίτησή σας υποβλήθηκε επιτυχώς με αριθμό πρωτοκόλλου: ",
  "Congratulations! Your application has been saved successfully!": "Συγχαρητήρια! Η αίτησή σας αποθηκέυτηκε επιτυχώς!",
  "You will be informed about the progress of your application by e-mail as soon as possible": "Θα ενημερωθείτε για την πρόοδο της αίτησης σας μέσω e-mail όσο το δυνατόν συντομότερο",
  "You can see your application at any time by going to 'My applications' page": "Μπορείτε να δείτε τις αιτήσεις σας οποιαδήποτε στιγμή επισκέπτοντας τη σελίδα 'Οι αιτήσεις μου'",
  "Documents list": "Λίστα δικαιολογητικών",
  'Upload file': 'Μεταφόρτωση αρχείου',
  'Required documents missing': 'Υπολείπονται απαραίτητα δικαιολογητικά',
  'Initial submission': 'Αρχική υποβολή',
  'Action required from you': "Απαιτείται ενέργεια από εσάς",
  'No': 'Όχι',
  'Yes': 'Ναι',
  'Old status': 'Προηγούμενη κατάσταση',
  'New status': 'Νέα κατάσταση',
  "To continue editing and submit it, you can go to 'My applications' page": "Για να συνεχίσετε να την επεξεργάζεστε και να την υποβάλλετε, μπορείτε να πάτε στη σελίδα 'Οι αιτήσεις μου'",
  "The document has been approved": "Το δικαιολογητικό έχει εγκριθεί",
  "The document has been rejected": "Το δικαιολογητικό έχει απορριφθεί",
  "The document is being processed": "Το δικαιολογητικό βρίσκεται υπό επεξεργασία",
  "Reason": "Αιτία",
  "There are documents that have been rejected by the service": "Υπάρχουν δικαιολογητικά τα οποία έχουν απορριφθεί απο την υπηρεσία",
  "Please upload new ones": "Παρακαλώ μεταφορτώστε τα εκ νέου",
  "An error occured": "Προέκυψε κάποιο σφάλμα",
  "No referrals": "Δεν υπάρχουν παραπεμπτικά",
  "For the issuing of your document, you can arrive on": "Για την παραλαβή του εντύπου μπορείτε να προσέλθετε από την",
  "bringing with you 3 recent, coloured photographs 4,5 Χ 3,5": "προσκομίζοντας 3 έγχρωμες πρόσφατες φωτογραφίες 4,5 Χ 3,5 και τις αποδείξεις αγοράς του Ναυτικού φυλλαδίου",
  "to": "εώς",
  "Appointment": "Ραντεβού",
  "Invalid email": "Το email δεν είναι σωστό",
  "Pickup place": "Σημείο παραλαβής",
  "Required Applicant Details missing": "Υπολείπονται Στοιχεία Αιτούντα",


  // Sectors
  "Sectors": "Κλάδοι",
  "Sector": "Κλάδος",
  "Delete Sector": "Διαγραφή Κλάδου",
  "Are you sure you want to delete the selected Sector": "Είστε σίγουροι πως θέλετε να διαγράψετε τον επιλεγμένο Κλάδο",
  "Add a new Sector": "Προσθέστε νέο Κλάδο",
  "Fill in the form below and click on Add to add a new Sector": "Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Προσθήκη για να προσθέσετε ένα νέο Κλάδο ",
  "Fill in the form below and then click on Save to update the Sector": "Συμπληρώστε την ακόλουθη φόρμα και έπειτα πατήστε Αποθήκευση για να ενημερώστε τον επιλεγμένο Κλάδο",
  "Please select a Sector": "Παρακαλώ επιλέξτε έναν κλάδο",

  // User statistics
  "User statistics": "Στατιστικά χρηστών",
  "Show": "Εμφάνιση",
  "Hide": "Απόκρυψη",
  "column totals": "συνόλων στηλών",
  "column grand totals": "γενικών συνόλων στηλών",
  "row grand totals": "γενικών συνόλων γραμμών",
  "Grand total": "Γενικό σύνολο",
  "Month": "Μήνας",
  "Year": "Έτος",
  "January": "Ιανουάριος",
  "February": "Φεβρουάριος",
  "March": "Μάρτιος",
  "April": "Απρίλης",
  "May": "Μάιος",
  "June": "Ιούνιος",
  "July": "Ιούλιος",
  "August": "Αύγουστος",
  "September": "Σεπτέμβριος",
  "October": "Οκτώβριος",
  "November": "Νοέμβριος",
  "December": "Δεκέμβριος",

  "Please fill in all required fields": "Παρακαλώ συμπληρώστε όλα τα απαραίτητα πεδία",

  "Are you sure you want to cancel this application? This action cannot be undone and the progress of your application will be lost": "Είστε σίγουροι πώς θέλετε να ακυρώστε την αίτηση; Αυτή η δράση δεν είναι αναστρέψιμη και η πρόοδος της αίτησής σας θα χαθεί",
  "Yes, I want to cancel this application": "Ναι, θέλω να ακυρώσω την αίτηση",
  "No, I want to continue applying": "Όχι, θέλω να συνεχίσω την αίτηση",
  "Your application has been cancelled!": "Η αίτησή σας ακυρώθηκε",
  "Postpone": "Αναβολή",
  "You can fill in below any comments and desired dates for a new appointment": "Μπορείτε να συμπληρώσετε παρακάτω τυχόν σχόλια και επιθυμητές ημερομηνίες για καινούριο ραντεβού",
  "Postpone appointment": "Αναβολή ραντεβού",
  "Emails": "Email",
  "Application id": "id Αίτησης",
  "Sent date": "Ημ/νία αποστολής",
  "Email body": "Περιεχόμενο email",

  "Ship Configuration": "Σύνθεση Πλοίου",

  "Specialization": "Ειδίκευση",
  "Count": "Πλήθος",

  "Are you sure you want to delete the selected item": "Είστε σίγουροι πώς θέλετε να διαγράψετε το επιλεγμένο στοιχείο",

  "Edit Sector": "Επεξεργασία Κλάδου",

  "Sail until": "Ελευθεροπλοΐα εώς",

  "Start Place": "Τόπος Ναυτολόγησης",

  "View History": "Προβολή Ιστορικού",
  "Insert new Configuration": "Εισαγωγή νέας Σύνθεσης",
  "Update Configuration": "Επεξεργασία Σύνθεσης",

  //Application Info
  "Choose appplication kind to view the associated info": "Επιλέξτε το Είδος αίτησης για να δείτε τις πληροφορίες της συγκεκριμένης αίτησης",
  "I have read the info about": "Έχω διαβάσει τις πληροφορίες για την",
  "I certify that i have been informed": "Βεβαιώνω ότι ενημερώθηκα και συναινώ για την τήρηση και την επεξεργασία των προσωπικών μου δεδομένων για τη διεκπεραίωση της αίτησής μου",
  "Blue Nautical": "ΠΔ 104/2020 (μπλε ΝΦ)",
  "Red Nautical": "ΠΔ 260/2001 (κόκκινο ΝΦ)",
  "Nautical Issue Lost or Stolen": "Κλοπή ή απώλεια ναυτικού φυλλαδίου",
  "Change Color of Nautical Issue": "Aλλαγή χρώματος ναυτικού φυλλαδίου",
  "For high school graduates and higher level": "A) Για απόφοιτους Γυμνασίου και ανώτερο επίπεδο,",
  "Holders of a degree or certificate of Rescue & Firefighting": "Β) Κατόχους πτυχίου ή βεβαίωσης Σωστικών & Πυροσβεστικών μέσων",
  "For primary and higher level graduates": "A) Για απόφοιτους Δημοτικού και ανώτερο επίπεδο,",
  "Time limit for presenting a degree or certification of Rescue & Firefighting , 9 months from the issuance of the NF": "B) Χρονικό όριο προσκόμισης πτυχίου ή βεβαίωσης Σωστικών & Πυροσβεστικών μέσων , 9 μήνες από την έκδοση του Ναυτικού Φυλλαδίου",
  "Information about the application": "Πληροφορίες σχετικά με την αίτηση",

  //Applications Summary
  "Applications Summary": "Στοιχεία Αιτήσεων",

  "Image is not correct": "Το αρχείο που ανεβάσατε δεν είναι φωτογραφία. Παρακαλώ ανεβάστε φωτογραφία με format .jpef,.png,.jpg κατάληξη.",
  "Image should up to 3mb": "Η φωτογραφία θα πρέπει να είναι μέχρι 3mb σε μέγεθος",
  "Image should 4:6": "Η φωτογραφία θα πρέπει να είναι 4:6 πλάτος επί ύψος π.χ. 800x1200",
  "Photo Requirements": "Η φωτογραφία θα πρέπει να είναι μέχρι 3mb σε μέγεθος με format .jpef,.png,.jpg κατάληξη.",
  "Reason for copy nautical issue": "Λόγος για αντίγραφο ναυτικού φυλλαδίου",

  "You can download here the form": "Μπορείτε να κατεβάσετε την φόρμα εδώ με προσυμπληρωμένο το κείμενο αλλά θα πρέπει να επικυρωθεί μέσω e-gov.gr",
  "Download": "Λήψη",

  //Custom GovGr Translations
  "Field can't be edited": "Το πεδίο δεν μπορεί να τροποποιηθεί",
  "Day": "Ημέρα",
  "Invalid date": "Λανθασμένη ημερομηνία",
  "Choose Here": "Επιλέξτε εδώ",

  // Amka Verification Page

  "Please type your AMKA number in the below field": "Παρακαλούμε πληκτρολογήστε παρακάτω τον αριθμό του ΑΜΚΑ σας.",
  "Wrong AMKA": "Το ΑΜΚΑ που πληκτρολογήσατε είναι λάθος.Παρακαλούμε πληκτρολογήστε το σωστό ή μεταβείτε σε ένα ΚΕΠ για να επικαιροποιήσετε τα στοιχεία σας.",
  "Gateway Data": "Δεδομένα Διαλειτουργικοτήτων",
  "Please upload identification document": "Παρακαλούμε ανεβάστε την ταυτότητα",
  "Field must be checked": "To πεδίο δεν είναι επιλεγμένο",
  "Didactic Year": "Διδακτικό Έτος Αποφοίτησης",
  "Please upload eparavolo_copy_nautical_issue": "Παράβολο ∆ημοσίου Ταμείου ή διπλότυπο είσπραξης ή e-παράβολο 31,17 €(κωδ.3035) για ΑΤΤΙΚΗ Ή 41,17€ για υπόλοιπη Ελλάδα(κωδ.3036)",
  "Please upload your High Scool Diploma": "Παρακαλώ ανεβάστε το Απολυτήριο Γυμνασίου ή ανώτερης Βαθμίδας",
  "Please upload your Primary School Leaving Certificate": "Παρακαλώ ανεβάστε το Απολυτήριο Δημοτικού",
  "criminal": "Ποινικό Μητρώο",
  "stratologia": "Στρατολογία",
  "student_attendance": "Έχει φοιτήσει σε",
  "digital_diploma": "Έχει απολυτήριο",
  "mitroo": "Μητρώο πολιτών",
  "criminal_record_hasPines": "Έχει ποινικό μητρώο",
  "criminal_record_status": "Στάτους",
  "criminal_record_requestId": "Αρ.Πρωτοκόλλου Ποινικού Μητρώου",
  "criminal_record_prdDate": "Ημ/νία Έκδοσης Ποινικού Μητρώου",
  "criminal_record_prdNumber": "Αριθμός Έκδοσης Ποινικού Μητρώου",
  "stratologia_message": "Μήνυμα για στρατιωτική κατάσταση",
  "stratologia_status": "Status",
  "student_attendance_resultCode": "Έχει τελειώσει το",
  "student_attendance_status": "Στάτους",
  "digital_diploma_levelName": "Απολυτήριο",
  "digital_diploma_status": "Στάτους",
  "mitroo_municipalityName": "Δήμος",
  "mitroo_merida": "Μερίδα",
  "mitroo_member": "Μέλος",
  "mitroo_status": "Στάτους Μητρώου",
  "mitroo_place_birth_id": "ID Τόπου γέννησης",
  "mitroo_place_birth": "Τόπος γέννησης",
  "mitroo_birthForeignCity": "Πόλη εξωτερικού",
  "mitroo_nationality": "Εθνικότητα",
  "mitroo_port_auth": "Λιμενική αρχή",
  "mitroo_port_auth_id": "ID Λιμενικής αρχής",
  "mitroo_gender": "Φύλο",
  "mitroo_dt_birth": "Ημερομηνία γέννησης",
  "mitroo_tk": "ΤΚ",
  "mitroo_address_nr": "Αριθμός διεύθυνσης",
  "mitroo_address": "Διεύθυνση",
  "mitroo_moth_fname": "Όνομα μητρός",
  "mitroo_moth_lname": "Επώνυμο μητρός",
  "mitroo_fath_lname": "Επώνυμο πατρός",
  "mitroo_fath_fname": "Όνομα πατρός",
  "mitroo_ind_nr": "Αριθμός ταυτότητας",
  "mitroo_fname": "Όνομα",
  "mitroo_lname": "Επώνυμο",
  "mitroo_lnameA": "Επώνυμο (αφορά)",
  "mitroo_lnameΕ": "Επώνυμο (αιτούντα)",
  "Wrong_ADT": "Aν είναι λάθος παρακαλώ ανεβάστε αντίγραφο ταυτότητας",
  "Birth Country": "Χώρα Γέννησης",
  "Birth City Abroad": "Πόλη Γέννησης Εξωτερικό",
  "eParavolo": "eParavolo",
  "Submit eParavolo": "Υποβολή Παραβόλου",
  "Create eParavolo": "Δημιουργία Παραβόλου",
  "eParavoloUseorCreate": "Παρακάτω μπορείτε να υποβάλλετε το παράβολο το οποίο έχετε πληρώσει ή να δημιουργήσετε ένα το οποίο θα πρέπει να πληρώσετε μέσω τραπέζης ή ηλεκτρονικά",
  "Paravolo Code": "20 ψήφιος κωδικός Παραβόλου",
  "Rf_Code_Payment": "RF Κωδικός Πληρωμής",
  "eParavoloCreated": "Ο κωδικός RF παραβόλου είναι ",
  "Application_not_status_eParavolo": "Η κατάσταση της αιτησής σας δεν είναι στην Δημιουργία ή Υποβολή Παραβόλου.",
  "eParavolo_not_payed": "To eParavolo δεν έχει πληρωθεί ακόμα",
  "eParavolo_bound": "Το eParavolo είναι δεσμευμένο, παρακαλούμε εκδώσετ καινούριο",
  "eParavolo_cancelled": "Το eParavolo είναι ακυρωμένο , παρακαλούμε εκδώστε καινούριο",
  "eParavolo_Payment_Processing": "Η πληρωμή του eParavolo είναι σε εξέλιξη περιμένετε 1-2 εργάσιμες μέρες",
  "Please type your 20 digit Paravolo Code (NOT RF CODE)": "Πληκτρολογήστε τον 20ψήφιο κωδικό παραβόλου(όχι κωδικό πληρωμής)",
  "Paravolo RF Code": "Κωδικός RF eParavolo",
  "eParavoloPaymentCreated": "O κωδικός παραβόλου είναι",
  "eParavolo_Use_BackOffice": "Πατώντας το παρακάτω κουμπί δεσμεύετε το παράβολο που έχει βγάλει ο πολίτης και μπορείτε να προχωρήσετε σε επόμενο status",
  "Paravolo has not been paid": "To eParavolo δεν έχει πληρωθεί ακόμα,ή έχει χρησιμοποιηθεί ξανά. Θα πρέπει ο πολίτης να βάλει καινούριο πληρωμένο παράβολο το οποίο δεν έχει χρησιμοποιηθεί",
  "useParavoloText": "Δέσμευση Παραβόλου",
  "eParavoloBound": "Το paravolo έχει δεσμευτεί επιτυχώς παρακαλούμε προχωρήστε σε έκδοση παραπεμπτικού",
  "Application_not_status_eParavolo_backOffice": "Δεν είστε σε κατάσταση έλεγχος παραβόλου",
  "You have been automatically logged out for being idle for more than 1 hour":
    "Αποσυνδεθήκατε αυτόματα από το σύστημα επειδή ήσασταν αδρανείς πάνω από 1 ώρα",
  "Data": "Δεδομένα",
  "EParavolo is not bound": "Το παράβολο δεν είναι δεσμευμένο",
  "From": "Από",
  "Please choose a date after which the applicant can arrive": "Παρακαλώ επιλέξτε μια ημερομηνία μετά την οποία ο αιτών μπορεί να προσέλθει για παραλαβή",
  "For the completion of your petition it is mandatory to validate your contact info": "Για την υποβολή της αίτησής σας είναι απαραίτητο να επικαιροποιηθούν τα στοιχεία επικοινωνίας σας (αριθμός κινητού τηλεφώνου, διεύθυνση ηλεκτρονικού ταχυδρομείου) στο Εθνικό Μητρώο Επικοινωνίας (https://notify.gov.gr)",
  "In the case that information you see is not correct, please update your info": "Σε περίπτωση που στοιχεία εμφανίζονται λανθασμένα, παρακαλώ ανανεώστε τα στο Εθνικό Μητρώο Επικοινωνίας"
};

export default Locale;
